import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { focusMeQueryOptions } from '@/entities/focus-session'
import { Button } from '@/shared/ui/button'
import { PageHeader } from '@/shared/ui/page-header'
import { Spinner } from '@/shared/ui/spinner'
import { FocusConsole, FocusPresence } from '@/widgets/focus-console'

export const Route = createFileRoute('/focus')({
  component: FocusPage,
  head: () => ({ meta: [{ title: 'Фокус · STIT Task' }] }),
})

// Фокус — одна страница без развилки «войти / не войти»: помодоро и режимы Endel
// сразу под рукой, а сессия открывается сама по первому из них.
function FocusPage() {
  const meQ = useQuery(focusMeQueryOptions)

  // Страница занимает всю высоту окна: помодоро, состояние и режимы расходятся
  // по ярусам, а не жмутся к шапке, оставляя пустоту внизу.
  return (
    <div className="container-x flex h-full min-h-0 flex-col px-4 py-4 sm:px-6 sm:py-6">
      <PageHeader title="Фокус" eyebrow="Концентрация" />
      <div className="mt-4 flex min-h-0 flex-1 flex-col">
        {meQ.isLoading ? (
          <div className="flex flex-1 items-center justify-center">
            <Spinner label="Загрузка фокуса" />
          </div>
        ) : meQ.isError ? (
          <div className="flex flex-1 flex-col items-center justify-center gap-3">
            <p className="text-sm text-text-secondary">Не удалось загрузить фокус-сессию.</p>
            <Button variant="secondary" onClick={() => void meQ.refetch()}>
              Повторить
            </Button>
          </div>
        ) : (
          <FocusConsole focusSession={meQ.data ?? null} />
        )}
      </div>

      {/* Presence — «кто ещё в фокусе»; строка мелкая, экран не распирает. */}
      {!meQ.isLoading && !meQ.isError && (
        <div className="mt-4 flex shrink-0 justify-center">
          <FocusPresence />
        </div>
      )}
    </div>
  )
}
